// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__JE9OB","selected":"Chip_selected__2t6tk"};